import React, { useEffect, useState } from 'react'
import { axiosGet } from '../../../util/api'
import { Layout } from '../../../components/Layout'
import { ClassValue } from 'classnames/types'
import cx from 'classnames'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { Link, useParams } from 'react-router-dom'
import {
    exportPieData,
    reportPieData,
    snapshotPieData,
    updateDetailsAtom,
} from './update_details_state'
import { updateStatusString } from '../../../constants/update_status'
import { adTypeString } from '../../../config'
import { format } from 'date-fns'
import { ChartData } from 'chart.js'
import { Pie } from 'react-chartjs-2'
import { UnsuccessfulSnapshots } from './UnsuccessfulSnapshots'
import { UnsuccessfulReports } from './UnsuccessfulReports'
import { updateDetailsLogState } from './update_details_log_state'
import { UpdateDetailLogs } from './UpdateDetailLogs'
import { UnsuccessfulExports } from './UnsuccessfulExports'

export const AdminUpdateDetails = () => {
    const { update_id } = useParams()
    const setLogs = useSetRecoilState(updateDetailsLogState)
    const [update, setUpdate] = useRecoilState(updateDetailsAtom)
    const [loading, setLoading] = useState(false)
    const [logsLoading, setLogsLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        axiosGet('admin/updates/' + update_id)
            .then((r) => {
                setUpdate(r.data)

                setLoading(false)
            })
            .catch(() => {
                setLoading(false)
            })

        setLogsLoading(true)
        axiosGet('admin/updates/' + update_id + '/logs')
            .then((r) => {
                console.log('logs', r.data)
                const data = r.data
                const rows = data.matches.map((x: any) => x.data)
                setLogs(rows)

                setLogsLoading(false)
            })
            .catch(() => {
                setLogsLoading(false)
            })
    }, [])

    return (
        <Layout
            primary={
                <span>
                    <Link to="/admin/updates" className="text-lg font-bold">
                        Updates
                    </Link>
                    <b className="text-lg">&nbsp;/ {update_id}</b>
                </span>
            }
        >
            <div className="flex gap-x-8 mb-8">
                <UserDetails />
                <UpdateDetails />
            </div>
            <div className="flex gap-x-8 mb-8 w-full">
                <SnapshotsPieChart />
                <UnsuccessfulSnapshots />
            </div>
            <div className="flex gap-x-8 mb-8 w-full">
                <ReportsPieChart />
                <UnsuccessfulReports />
            </div>
            <div className="flex gap-x-8 mb-8 w-full">
                <ExportsPieChart />
                <UnsuccessfulExports />
            </div>
            <UpdateDetailLogs />
        </Layout>
    )
}

const UserDetails = ({ className }: { className?: ClassValue }) => {
    const update = useRecoilValue(updateDetailsAtom)

    if (!update) {
        return null
    }

    return (
        <div className={cx('bg-white p-3 border rounded-md', className)}>
            <div>
                User Id:{' '}
                <Link to={`/admin/users/${update.profile.keys?.user_id}`}>
                    {update.profile.keys?.user_id}
                </Link>
            </div>
            <div>
                Profile Id:{' '}
                <Link to={`/admin/profiles/${update.profile.profile_id}`}>
                    {update.profile.profile_id}
                </Link>
            </div>
            <div>Marketplace: {update.profile.marketplace_id}</div>
            <div>Name: {update.profile.keys?.user?.name}</div>
            <div>Email: {update.profile.keys?.user?.email}</div>
        </div>
    )
}

const UpdateDetails = ({ className }: { className?: ClassValue }) => {
    const update = useRecoilValue(updateDetailsAtom)

    if (!update) {
        return null
    }

    return (
        <div className={cx('bg-white p-3 border rounded-md', className)}>
            <div>Update Id: {update.id}</div>
            <div>Status: {updateStatusString(update.status_id)}</div>
            <div>Platform: {adTypeString(update.platform_type_id)}</div>
            <div>Created At: {format(new Date(update.created_at), 'M/d/yy H:mm a')}</div>
            <div>Updated At: {format(new Date(update.updated_at), 'M/d/yy H:mm a')}</div>
        </div>
    )
}

const SnapshotsPieChart = () => {
    const data = useRecoilValue(snapshotPieData)
    return <MyPieChart title="Snapshots by Status" data={data} />
}

const ReportsPieChart = () => {
    const data = useRecoilValue(reportPieData)
    return <MyPieChart title="Reports by Status" data={data} />
}

const ExportsPieChart = () => {
    const data = useRecoilValue(exportPieData)
    return <MyPieChart title="Exports by Status" data={data} />
}

interface PieChartProps {
    title: string
    data: ChartData<'pie'>
}

const MyPieChart = ({ title, data }: PieChartProps) => {
    return (
        <div className="p-3 bg-white border rounded-md" style={{ maxWidth: '300px' }}>
            <div>{title}</div>
            <div>
                <Pie
                    data={data}
                    options={{
                        plugins: {
                            legend: {
                                position: 'right',
                            },
                        },
                    }}
                />
            </div>
        </div>
    )
}
